import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import opensea from "../assets/duck-images/opensea.webp"
import camelot from "../assets/duck-images/camelot.webp"
import { nftAddress } from '../eth/mumbai-testnet/nft-contract.json'
import { tokenAddress } from '../eth/mumbai-testnet/token-contract.json'




function Token({ ConnectWalletFunc, state, setState, disconnectWallet }) {

    return (
        <>
            <section className='token_section'>
                <div className="glass">
                    <Navbar ConnectWalletFunc={ConnectWalletFunc} isConnect={state} setIsConnect={setState} disconnectWallet={disconnectWallet} />
                </div>


                {
                    process.env.REACT_APP_ENVIRONMENT === "production" ?
                        <>
                            <div className="container">
                                <div className="row justify-content-center align-items-center">
                                    <div className="col-lg-6 col-md-6 col-12 cat_col mb-5">
                                        <div className="card mx-1">
                                            <div className="content">
                                                <div className='justify-content-center text-center'>
                                                    <h2>Duck Goose (ERC721)</h2>
                                                    <a href="#">
                                                        <p>{nftAddress}</p>
                                                    </a>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <div className="name">
                                                        <h3>Total Supply</h3>
                                                    </div>
                                                    <div className="value">
                                                        <h4>50,000</h4>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <div className="name">
                                                        <h3>Minted</h3>
                                                    </div>
                                                    <div className="value">
                                                        <h4>26,573</h4>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between mt-3'>
                                                    <div className="name">
                                                        <h3>Buy NFT:</h3>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between mt-3'>
                                                    <div className="name">
                                                        <a href="#">
                                                            <img src={opensea} alt="image" className='img-fluid' />
                                                            <h3>Opensea</h3>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12 cat_col mb-5">
                                        <div className="card mx-1">
                                            <div className="content">
                                                <div className='justify-content-center text-center'>
                                                    <h2>POND (ERC20)</h2>
                                                    <a href="#">
                                                        <p>{tokenAddress}</p>
                                                    </a>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <div className="name">
                                                        <h3>Total</h3>
                                                    </div>
                                                    <div className="value">
                                                        <h4>200,000,000</h4>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <div className="name">
                                                        <h3>Pond</h3>
                                                    </div>
                                                    <div className="value">
                                                        <h4>30,413,419</h4>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <div className="name">
                                                        <h3>Total Supply Now</h3>
                                                    </div>
                                                    <div className="value">
                                                        <h4>169,586,580</h4>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <div className="name">
                                                        <h3>Circulating Supply</h3>
                                                    </div>
                                                    <div className="value">
                                                        <h4>44,446,147</h4>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <div className="name">
                                                        <h3>FISH Reward</h3>
                                                    </div>
                                                    <div className="value">
                                                        <h4>2.411/BLOCK</h4>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <div className="name">
                                                        <h3>FISH Halving on BLOCK</h3>
                                                    </div>
                                                    <div className="value">
                                                        <h4>97,012,686</h4>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <div className="name">
                                                        <h3>FISH Halving Countdown</h3>
                                                    </div>
                                                    <div className="value">
                                                        <h4>28d 10h 19m 41s</h4>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between mt-3'>
                                                    <div className="name">
                                                        <h3>Buy FISH:</h3>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between mt-3'>
                                                    <div className="name">
                                                        <a href="#">
                                                            <img src={camelot} alt="image" className='img-fluid' />
                                                            <h3>Camelot</h3>
                                                        </a>
                                                    </div>
                                                    <div className="value">
                                                        <h4>DEX</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className="row justify-content-center align-items-center" style={{ height: "70vh" }}>
                                <div className="col-lg-6 col-md-6 col-12 cat_col mb-5">
                                    <div className="card connect_card mx-1">
                                        <div className="content" style={{ minHeight: "250px", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <h1 style={{ color: "#444c7f", fontSize: "40px" }}>Coming Soon!!!</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                }


                <Footer />
            </section>
        </>
    )
}



export default Token